import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Intro from "./pages/intro";
import President from "./pages/president";
import Map from "./pages/map";
import SIHF from "./pages/sihf";
import Notice from "./pages/notice";
import Admin from "./pages/admin";
import NoticeDetail from "./pages/noticeDetail";
import Question from "./pages/question";
import New from "./pages/new";
import { AuthProvider, useAuth } from "./components/AuthContext";
import Orchestra from "./pages/orchestra";

function App() {
  const hostname = window.location.hostname; // 현재 도메인 가져오기
  const isAdminSubdomain = hostname.startsWith("admin."); // 서브도메인이 admin인지 확인

  return (
    <AuthProvider>
      <div className="App">
        <Nav />
        <Routes>
          {/* 모든 도메인에서 동일한 라우트 구조를 유지 */}
          <Route path="/" element={isAdminSubdomain ? <Navigate to="/admin" /> : <Home />} />
          <Route path="/admin" element={<AdminWrapper />} />
          <Route path="/admin/new" element={<PrivateRoute component={<New />} />} />
          <Route path="/intro" element={<Intro />} />
          <Route path="/intro/map" element={<Map />} />
          <Route path="/intro/president" element={<President />} />
          <Route path="/orchestra" element={<Orchestra />} />
          <Route path="/sihf" element={<SIHF />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/notice/:id" element={<NoticeDetail />} />
          <Route path="/question" element={<Question />} />
        </Routes>
        <Footer />
      </div>
    </AuthProvider>
  );
}

function AdminWrapper() {
  const { setIsAuthenticated } = useAuth();
  return <Admin setIsAuthenticated={setIsAuthenticated} />;
}

function PrivateRoute({ component }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? component : <Navigate to="/" />;
}

export default App;